var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.3765 16 16 12.3686 16 8C16 3.62353 12.3686 0 7.99216 0C3.62353 0 0 3.62353 0 8C0 12.3686 3.63137 16 8 16ZM7.11373 11.8353C6.84706 11.8353 6.62745 11.7255 6.42353 11.451L4.4549 9.03529C4.33726 8.87843 4.26667 8.70588 4.26667 8.52549C4.26667 8.17255 4.54118 7.88235 4.89412 7.88235C5.12157 7.88235 5.29412 7.95294 5.4902 8.21176L7.08235 10.2667L10.4314 4.88627C10.5804 4.65098 10.7843 4.52549 10.9882 4.52549C11.3333 4.52549 11.6549 4.76078 11.6549 5.12941C11.6549 5.30196 11.5529 5.48235 11.4588 5.64706L7.77255 11.451C7.60784 11.7098 7.38039 11.8353 7.11373 11.8353Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.bcfe9cfa0c78ec8dcf3dd5f77921dc85.svg";
export { ForwardRef as ReactComponent };